module.exports = __webpack_public_path__ + "static/media/best_sellers_img.b953890b.svg";